var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2ECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.419 15.7741C10.3353 15.7741 10.2515 15.7558 10.1774 15.7279C9.81462 15.5884 9.63757 15.1881 9.7684 14.8253L12.5591 7.3836C12.6987 7.0208 13.099 6.84376 13.4618 6.97459C13.8246 7.11413 14.0016 7.51443 13.8708 7.87723L11.08 15.3189C10.978 15.598 10.7077 15.775 10.4286 15.775L10.419 15.7741Z",
    fill: "#292924"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3727 12.5185H13.0519L12.5312 13.9138H24.3736C24.5035 13.9138 24.6064 14.0159 24.6064 14.1467V15.0301L23.211 21.9974C23.0157 22.9741 22.1506 23.6814 21.1555 23.6814H10.8472C9.85211 23.6814 8.98698 22.9741 8.79163 21.9974L7.39626 14.983V14.1458C7.39626 14.0159 7.4983 13.9129 7.62912 13.9129H10.8847C10.9405 13.9129 10.9963 13.8946 11.0521 13.885L11.5641 12.5176L7.62823 12.5185C6.73519 12.5185 6 13.2536 6 14.1467V14.9839C6 15.0859 6.00959 15.1976 6.02791 15.3005L7.42328 22.2677C7.74857 23.896 9.19104 25.0681 10.8463 25.0681H21.1537C22.8099 25.0681 24.2514 23.8864 24.5767 22.2677L25.9721 15.3005C25.9904 15.1984 26 15.0868 26 14.9839V14.1467C26 13.2536 25.2648 12.5185 24.3718 12.5185L24.3727 12.5185Z",
    fill: "#292924"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6514 13.914C20.3627 13.914 20.0836 13.7282 19.9912 13.4396L18.131 7.8581C18.0098 7.4953 18.2051 7.095 18.5679 6.97466C18.9403 6.85344 19.331 7.04879 19.4513 7.41158L21.3115 12.9931C21.4328 13.3559 21.2374 13.7562 20.8746 13.8765C20.8005 13.9044 20.7255 13.914 20.6514 13.914Z",
    fill: "#292924"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3958 17.6351H14.6051C14.224 17.6351 13.9074 17.3185 13.9074 16.9374C13.9074 16.5563 14.224 16.2397 14.6051 16.2397H17.3958C17.7769 16.2397 18.0935 16.5563 18.0935 16.9374C18.0935 17.3185 17.7769 17.6351 17.3958 17.6351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFav);
export default __webpack_public_path__ + "static/media/defaultFav.f060850ce45641f9cd40adf0222304dc.svg";
export { ForwardRef as ReactComponent };